import WrapperMessageDispatcher from "./WrapperMessageDispatcher";
export default class BrowserLocationUtils {
    static replaceBrowserLocationHash(key, value) {
        // hashes can look like #key1=value1&key2=value2
        const hashKeyRegex = RegExp(`(#.*)(${key}=[^&]*)(.*)`, 'i');
        const normalizedValue = value.replace('#', '');
        if (hashKeyRegex.test(window.location.hash)) {
            window.location.hash = window.location.hash.replace(hashKeyRegex, `$1${key}=${normalizedValue}$3`);
        }
        else {
            window.location.hash = `${key}=${value}`;
        }
        BrowserLocationUtils.dispatchLocationNoSectionChangeMessage(window.location);
    }
    static buildLocationDescriptorObjectFromWindowLocation(location) {
        return {
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash,
            ...location
        };
    }
    static updateBrowserLocationHash(newHash) {
        // Update location
        window.location.hash = newHash;
        // Don't update left nav section on hash change
        BrowserLocationUtils.dispatchLocationNoSectionChangeMessage(window.location);
    }
    static updateBrowserLocation(newPath, newSearch = '', newHash = '') {
        const newLocation = {
            pathname: newPath,
            search: newSearch,
            hash: newHash
        };
        BrowserLocationUtils.dispatchLocationChangeMessage(newLocation);
    }
    static updateBrowserLocationWithForcePush(location) {
        // used for redirecting from React world to non-React world
        window.location.href = location;
    }
    static updateBrowserLocationWithPush(location, history) {
        // @ts-ignore
        history.push(location);
        BrowserLocationUtils.dispatchLocationChangeMessage(window.location);
    }
    static updateBrowserLocationWithReplace(newPath, history) {
        history.replace(newPath);
        BrowserLocationUtils.dispatchLocationChangeMessage(window.location);
    }
    /**
     * Use this function if you need to switch between modules in order to force an iframe reload.
     */
    static updateBrowserLocationWithTimeStampChange(newPath, newSearch = '', newHash = '') {
        WrapperMessageDispatcher.dispatchMessage('location_change_with_timestamp_change', {
            location: {
                pathname: newPath,
                search: newSearch,
                hash: newHash
            }
        });
    }
    static updateBrowserParamsWithoutReload(newSearch) {
        const tempUrl = new URL(window.location.origin + window.location.pathname + newSearch);
        WrapperMessageDispatcher.dispatchMessage('location_change_no_section_change', {
            location: {
                pathname: tempUrl.pathname,
                search: newSearch,
                hash: tempUrl.hash
            }
        });
    }
    static updateBrowserLocationWithoutReload(newPath, history) {
        const tempUrl = new URL(window.location.origin + newPath);
        WrapperMessageDispatcher.dispatchMessage('location_change_no_section_change', {
            location: {
                pathname: tempUrl.pathname,
                search: tempUrl.search,
                hash: tempUrl.hash
            }
        });
    }
    static replaceBrowserLocation(newPath) {
        const tempUrl = new URL(window.location.origin + newPath);
        WrapperMessageDispatcher.dispatchMessage('location_change_replace', {
            location: {
                pathname: tempUrl.pathname,
                search: tempUrl.search,
                hash: tempUrl.hash
            }
        });
    }
    static replaceBrowserLocationNoSectionChange(newPath) {
        const tempUrl = new URL(window.location.origin + newPath);
        WrapperMessageDispatcher.dispatchMessage('location_change_replace_no_section_change', {
            location: {
                pathname: tempUrl.pathname,
                search: tempUrl.search,
                hash: tempUrl.hash
            }
        });
    }
    static buildLocationUrlFromHistory(history) {
        const location = history.location;
        return `${location.pathname}${location.search}${location.hash}`;
    }
    static dispatchLocationChangeMessage(location) {
        WrapperMessageDispatcher.dispatchMessage('location_change', {
            location: {
                pathname: location.pathname,
                search: location.search,
                hash: location.hash
            }
        });
    }
    static dispatchLocationNoSectionChangeMessage(location) {
        WrapperMessageDispatcher.dispatchMessage('location_change_no_section_change', {
            location: {
                pathname: location.pathname,
                search: location.search,
                hash: location.hash
            }
        });
    }
}
//# sourceMappingURL=BrowserLocationUtils.js.map